export const renderCheckedFilters = function () {
  const filters = document.querySelectorAll('.filter-type ul li');
  const params = new URLSearchParams(window.location.search);
  const paramVals = [...params.values()];
  filters.forEach((filter) => {
    const inputEl = filter.querySelector('input');
    let text = filter.querySelector('span').textContent.toLowerCase();

    text = text === 'multifunction machines' ? 'printers' : text;
    text.trim().split(' ').join('');

    if (paramVals.includes(text)) inputEl.checked = true;
  });

  // * RENDERING SORTBy
  const sortInput = document.querySelector('.fil-sort select');
  const sortBy = params.get('sort');
  console.log(sortBy);
  if (sortBy === '-createdAt') {
    sortInput.value = 'newest';
  } else if (sortBy === '-discountedPrice') {
    sortInput.value = 'hightolow';
  } else if (sortBy === 'discountedPrice') {
    sortInput.value = 'lowtohigh';
  }
};
